import React from 'react';

import theme from '@/styles/theme';

interface Props {
  color?: string;
  size?: number;
  style?: React.CSSProperties;
}
const ArrowsButtonDownMin = ({ color = theme.color.gray400, size = 16, style }: Props) => {
  return (
    <svg style={style} width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.3594 5.40002L8.03125 8.8219L4.70312 5.40002L3.75 6.3219L8.03125 10.7281L12.3125 6.3219L11.3594 5.40002Z'
        fill={color}
      />
    </svg>
  );
};

export default ArrowsButtonDownMin;
